export default function () {
  // 违章记录详情数据
  const list = [
    {
      key: 'plateNo',
      name: '车牌号',
    },
    {
      key: 'violationTime',
      name: '违章时间',
    },
    {
      key: 'customerName',
      name: '相关客户',
    },
    {
      key: 'orderId',
      name: '相关订单',
    },
    {
      key: 'content',
      name: '违章内容',
    },
    {
      key: 'penaltyPoint',
      name: '违章扣分',
    },
    {
      key: 'handleState',
      name: '处理状态',
    },
    {
      key: 'penaltyAmount',
      name: '违章罚款',
    },
    {
      key: 'paymentState',
      name: '缴款状态',
    },
    {
      key: 'handleRemarks',
      name: '备注',
    },
    {
      key: 'handleCompleteTime',
      name: '处理时间',
    },
    {
      key: 'dealViolationWay',
      name: '处理方式',
    },
    {
      key: 'latestUpdateTime',
      name: '最后更新时间',
    },
  ]
  return {
    list,
  }
}
